<div class="product-list-item">
  <div class="col-12 col-md-2 product-list-item-img">

    @if (product.pdpLinkFlag) {
    <a [attr.aria-label]="
        !product.images?.hasOwnProperty('PRIMARY')
          ? ('productDetails.noProductImage'
            | cxTranslate: { product: product.name })
          : undefined
      " [routerLink]="{cxRoute:'product',params:product}|cxUrl" class="cx-product-image-container">
      <cx-media class="cx-product-image" [container]="product.images?.PRIMARY || product.images" format="product"
        [alt]="product.name || product.summary"></cx-media>
    </a>
    }

    @if (!product.pdpLinkFlag) {
    <a [attr.aria-label]="
    !product.images?.hasOwnProperty('PRIMARY')
      ? ('productDetails.noProductImage'
        | cxTranslate: { product: product.name })
      : undefined
  " class="cx-product-image-container no-cursor">
      <cx-media class="cx-product-image" [container]="product.images?.PRIMARY" format="product"
        [alt]="product.name || product.summary"></cx-media>
    </a>
    }

  </div>
  <div class="d-flex col-12 col-md-10 kb-product-item-login-block">
    <div class="d-flex flex-column col-md-3">
      @if (product.pdpLinkFlag) {
      <a [routerLink]="{cxRoute:'product',params:product}|cxUrl" class="cx-product-name">
        <label class="product-code" [innerHtml]="product?.code| searchHighlight:searchQuery"></label>
      </a>
      }
      @if (!product.pdpLinkFlag) {
      <a class="cx-product-name no-cursor">
        <label class="product-code" [innerHtml]="product?.code | searchHighlight:searchQuery"></label>
      </a>
      }
      <label class="label-style product-typeNumber"
        [innerHtml]="product?.typenumber | searchHighlight:searchQuery "></label>

      <label class="label-style productName" [innerHtml]="product?.name | searchHighlight:searchQuery "></label>

      @if (product?.sapEan) {
      <label class="label-style">GTIN : <span
          [innerHtml]="product?.sapEan | searchHighlight:searchQuery "></span></label>
      }

      <div class="compare_checkbox" [ngStyle]="{'visibility':product&&product.pdpLinkFlag ? 'visible':'hidden'}">
        <app-check-box-compare [product]="product"></app-check-box-compare>
      </div>
    </div>
    <div class="col-md-3 d-flex flex-column">
      <label class="label-style product-Statuscode"
        [ngClass]="product.salesStatusCode=='CODE30' || product.salesStatusCode=='CODE40' ||product.salesStatusCode=='code30' || product.salesStatusCode=='code40'?'green-color':''">
        @if (product.salesStatusText?.indexOf('common.')<0) { <span class="product-list-product-name"
          [innerHtml]="product?.salesStatusText | searchHighlight:searchQuery "></span>
          }
          @if (product.salesStatusText?.indexOf('common.')>-1) {
          <span>@if (product.salesStatusText) {
            <span>{{product.salesStatusText|cxTranslate}}</span>
            }</span>
          }
      </label>

      <label class="label-style" [innerHtml]="product?.marketType | searchHighlight:searchQuery"></label>

      @if (product.replacedByProductCode && product.replaceByText) {
      <label class="mt-20"><span class="label-style">{{product.replaceByText|cxTranslate}}</span> <a
          class="replaceByText" [class.active]="product.replacedByPDPUrl" [href]="product.replacedByPDPUrl"
          [innerHtml]="product?.replacedByProductCode | searchHighlight:searchQuery "></a></label>
      }

      @if (product?.imppList[0]?.split(':').length>1 && product.imppText) {
      <label class="d-flex"><span class="label-style">{{product.imppText|cxTranslate}} </span>
        @if (product?.imppList[0]?.split(':')[2] == 'false') {
        <span class="imp-value m-l" [innerHtml]="product.imppList[0].split(':')[0] |searchHighlight:searchQuery"></span>
        }
        @if (product?.imppList[0]?.split(':')[2] == 'true') {
        <a class="imp-value m-l" [href]="product?.imppList[0]?.split(':')[1]"
          [innerHtml]="product.imppList[0].split(':')[0] |searchHighlight:searchQuery"></a>
        }
      </label>
      }

    </div>
    <div class="col-md-3 d-flex flex-column priceBarDiv">
      @if (fleetPrideGroup) {
      @if (product.customerPriceText) {
      <label class="label-style d-flex justify-content-between">{{product.customerPriceText|cxTranslate}}
        @if (!product.listPrice?.formattedValue || product.listPrice?.formattedValue.indexOf('-') > -1) {
        <span class="font-bold">@if (product.customerPriceText) {
          <span>{{'common.basket_page_poa'|cxTranslate}}</span>
          }</span>
        }
        @if (product.listPrice?.formattedValue && product.listPrice?.formattedValue.indexOf('-') < 0) { <span
          class="font-bold">{{product.listPrice?.formattedValue}}&nbsp;{{product.listPrice?.currencyIso}}</span>
          }
      </label>
      }
      @if (product.netPriceText) {
      <label class="label-style d-flex justify-content-between">{{product.netPriceText|cxTranslate}}
        @if (!product.netPrice?.formattedValue|| product.netPrice?.formattedValue.indexOf('-') > -1) {
        <span class="font-bold">@if (product.priceOnRequestText) {
          <span>{{'common.basket_page_poa'|cxTranslate}}</span>
          }</span>
        }
        @if (product.netPrice?.formattedValue && product.netPrice?.formattedValue.indexOf('-') < 0) { <span
          class="font-bold">{{product.netPrice?.formattedValue}}&nbsp;{{product.netPrice?.currencyIso}}</span>
          }
      </label>
      }
      @if (product.coreDepositeText) {
      <label class="label-style d-flex justify-content-between">{{product.coreDepositeText|cxTranslate}}
        @if (!product.corePrice?.formattedValue|| product.corePrice?.formattedValue.indexOf('-') > -1) {
        <span class="font-bold">@if (product.priceOnRequestText) {
          <span>{{'common.basket_page_poa'|cxTranslate}}</span>
          }</span>
        }
        @if (product.corePrice?.formattedValue && product.corePrice?.formattedValue.indexOf('-') < 0) { <span
          class="font-bold">{{product.corePrice?.formattedValue}}&nbsp;{{product.corePrice?.currencyIso}}</span>
          }
      </label>
      }
      }
    </div>
    <div class="col-md-3 no-padding product-list-button-block">
      @if (isLoggedIn && product.isCheckAvailibility) {
      <button (click)="checkAvailability(product.code)"
        class='fs-16 btn btn-secondary btn-block check-avl check-avl-btn check-available'>{{'common.check_availability_btn_text'|cxTranslate}}</button>
      }
      <app-kb-add-to-cart [showQuantity]="false" [purchasable]="product.isAddToCart" [productCode]="product?.code"
        class="kb-product-addToCart" [whichPage]="'PLP'"></app-kb-add-to-cart>
      @if (isLoggedIn && product.isQoute) {
      <button [disabled]="product.listPrice?.formattedValue" (click)="createAQuote(product.code)"
        class='btn btn-primary btn-block check-avl'>{{'common.quote_create'|cxTranslate}}</button>
      }
      @if (product.isContactUs && isLoggedIn && !product.isQoute) {
      <a class='btn btn-primary btn-block check-avl' [href]="product?.contactUsUrl"
        target="_blank">{{'common.pdp_page_contact_us'|cxTranslate}}</a>
      }
      @if (product.isEnqury && isLoggedIn) {
      <a [href]="'mailto:' + product?.contactEmail + '?subject=' + product?.code"
        class='btn btn-primary btn-block check-avl enquiry-btn'>
        {{ 'common.pdp_page_contact_enquiry' | cxTranslate }}
        <img src="/icons/mail-white.svg" alt="Enquiry" class="mail-icon" width="20" />
      </a>
      }
    </div>

  </div>
</div>